export default __webpack_public_path__ + "static/solid-background-cdd598207dd8e48e86e947444d99b8de.png";